import { connect } from "react-redux"
import Filters from "."
import { clearAssetFilters, clearStaticFilters } from "../../store"

const mapDispatchToProps = dispatch => ({
  onReset: () => {
    dispatch(clearAssetFilters())
    dispatch(clearStaticFilters())
  },
})

const FiltersWithStore = connect(null, mapDispatchToProps)(Filters)

export default FiltersWithStore
